import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "../../../../environments/environment";
import { map } from "rxjs";
import { AddOrEditCategoryModel } from "../../models/categories/add-or-edit-category.model";
import { AddOrEditSubcategoryModel } from "../../models/subcategories/add-or-edit-subcategory.model";
import { AddOrEditMenuItemModel } from "../../models/menu-items/add-or-edit-menu-item.model";
import { AddOrEditMenuRequestModel } from "../../models/menus/add-or-edit-request.model";
import { AssignVenuesMenuModel } from "../../models/menus/assign-venue-menu.model";
import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
import { TaxRateModel } from "../../models/tax-rates/tax-rate.model";

const GMN_MENUS_API = environment.apiURL + '/api/gmn/Menu/';
const MNG_MENUS_API = environment.apiURL + '/api/mng/Menu/';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }
  //#endregion

  //#region Public Methods
  listCategoryForCompany(companyId: string) {
    let url = GMN_MENUS_API + "listcategoryforcompany?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listAllMenus(companyId: string) {
    let url = GMN_MENUS_API + "listallmenus?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listAllMenusForVenue(venueId: string) {
    let url = MNG_MENUS_API + "listallmenus?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listCategoryForMenu(menuId: string) {
    let url = GMN_MENUS_API + "listcategoryformenu?MenuId=" + menuId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listSubcategoryForCompany(companyId: string) {
    let url = GMN_MENUS_API + "listsubcategoryforcompany?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listSubcategoryForCategory(categoryId: string) {
    let url = GMN_MENUS_API + "listsubcategoryforcategory?CategoryId=" + categoryId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listItemsForCompany(companyId: string) {
    let url = GMN_MENUS_API + "listitemsforcompany?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listItemsForCategory(categoryId: string) {
    let url = GMN_MENUS_API + "listitemsforcategory?CategoryId=" + categoryId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listItemsForSubcategory(subcategoryId: string) {
    let url = GMN_MENUS_API + "listitemsforsubcategory?SubCategoryId=" + subcategoryId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewCategory(categoryId: string) {
    let url = GMN_MENUS_API + "viewcategory?CategoryId=" + categoryId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewSubcategory(subcategoryId: string) {
    let url = GMN_MENUS_API + "viewsubcategory?SubCategoryId=" + subcategoryId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewMenuItem(menuItemId: string) {
    let url = GMN_MENUS_API + "viewmenuitem?ItemId=" + menuItemId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewMenu(menuId: string, roles?: Array<RoleNameEnum>) {
    let url = !roles || roles.includes(RoleNameEnum.PosGeneralManager) ? GMN_MENUS_API : MNG_MENUS_API;
    url += "viewmenu?MenuId=" + menuId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteMenu(id: string) {
    let url = GMN_MENUS_API + 'deletemenu';
    return this._httpService.httpPost(url, {id})
      .pipe(map(response => {
        return response;
      }));
  }

  deleteCategory(id: string) {
    let url = GMN_MENUS_API + 'deletecategory';
    return this._httpService.httpPost(url, {id})
      .pipe(map(response => {
        return response;
      }));
  }

  deleteSubcategory(id: string) {
    let url = GMN_MENUS_API + 'deletesubcategory';
    return this._httpService.httpPost(url, {id})
      .pipe(map(response => {
        return response;
      }));
  }

  deleteMenuItem(id: string) {
    let url = GMN_MENUS_API + 'deletemenuitem';
    return this._httpService.httpPost(url, {id})
      .pipe(map(response => {
        return response;
      }));
  }

  createMenu(model: AddOrEditMenuRequestModel) {
    let url = GMN_MENUS_API + 'createmenuwithcategories';
    return this._httpClient
      .post<any>(url, model, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  createCategory(model: AddOrEditCategoryModel, filePicture: any) {
    let url = GMN_MENUS_API + 'createcategory';
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('CompanyId', model.companyId);
    formData.append('LanguageId', model.languageId.toString());
    formData.append('ImageFile', filePicture as string);
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  createSubcategory(model: AddOrEditSubcategoryModel, filePicture: any) {
    let url = GMN_MENUS_API + 'createsubcategory';
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('ParentId', model.parentId);
    formData.append('CompanyId', model.companyId);
    formData.append('LanguageId', model.languageId.toString());
    formData.append('ImageFile', filePicture as string);
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  createMenuItem(model: AddOrEditMenuItemModel, filePicture: any) {
    let url = GMN_MENUS_API + 'createmenuitem';
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('CompanyId', model.companyId);
    formData.append('CompanyMenuCategoryId', model.companyMenuCategoryId);
    formData.append('Price', model.price.toString());
    formData.append('LanguageId', model.languageId.toString());
    formData.append('ImageFile', filePicture as string);
    formData.append('MenuItemTypeId', model.menuItemTypeId.toString());
    formData.append('TaxRateId', model.taxRateId);
    model.subvenueIds.forEach((subvenue, index) => {
      formData.append(`SubvenueIds[${index}]`, subvenue);
    });
    if(model.supplies){
      for (let i = 0; i < model.supplies.length; i++) {
        formData.append(`Supplies[${i}].supplyId`,String(model.supplies[i].supplyId));
        formData.append(`Supplies[${i}].quantity`,String(model.supplies[i].quantity));
      }
    }
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  updateCategory(model: AddOrEditCategoryModel, filePicture: any) {
    let url = GMN_MENUS_API + 'updatecategory';
    const formData: FormData = new FormData();
    formData.append('Id', model.id);
    formData.append('Name', model.name);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('LanguageId', model.languageId.toString());
    if (filePicture) {
      formData.append('ImageFile', filePicture as string);
    }
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  updateSubcategory(model: AddOrEditSubcategoryModel, filePicture: any) {
    let url = GMN_MENUS_API + 'updatesubcategory';
    const formData: FormData = new FormData();
    formData.append('Id', model.id);
    formData.append('Name', model.name);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('ParentId', model.parentId);
    formData.append('LanguageId', model.languageId.toString());
    if (filePicture) {
      formData.append('ImageFile', filePicture as string);
    }
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  editMenuItem(model: AddOrEditMenuItemModel, filePicture: any) {
    let url = GMN_MENUS_API + 'updatemenuitem';
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    formData.append('Id', model.id);
    if (model.description) {
      formData.append('Description', model.description);
    }
    formData.append('CompanyId', model.companyId);
    formData.append('CompanyMenuCategoryId', model.companyMenuCategoryId);
    formData.append('Price', model.price.toString());
    formData.append('LanguageId', model.languageId.toString());
    formData.append('MenuItemTypeId', model.menuItemTypeId.toString());
    formData.append('TaxRateId', model.taxRateId);
    model.subvenueIds.forEach((subvenue, index) => {
      formData.append(`SubvenueIds[${index}]`, subvenue);
    });
    if(model.supplies){
      for (let i = 0; i < model.supplies.length; i++) {
        formData.append(`Supplies[${i}].supplyId`,String(model.supplies[i].supplyId));
        formData.append(`Supplies[${i}].quantity`,String(model.supplies[i].quantity));
      }
    }
    if (filePicture) {
      formData.append('ImageFile', filePicture as string);
    }    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  listCurrencies(companyId: string) {
    let url = GMN_MENUS_API + "listcurrenciesformenu?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  getDefaultCurrency(companyId: string, roles?: Array<RoleNameEnum>) {
    let url = !roles || roles.includes(RoleNameEnum.PosGeneralManager) ? GMN_MENUS_API : MNG_MENUS_API;
    url += "getdefaultcurrency?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  addMenuToVenues(assignVenuesModel: AssignVenuesMenuModel) {
    let url = GMN_MENUS_API + 'addmenutovenues';
    return this._httpService.httpPost(url, assignVenuesModel)
      .pipe(map(response => {
        return response;
      }));

  }

  editMenu(model: AddOrEditMenuRequestModel) {
    let url = GMN_MENUS_API + 'updatemenuwithcategories';
    return this._httpClient
      .post<any>(url, model, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  listAllTaxRates() {
    let url = GMN_MENUS_API + 'listalltaxrates';
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listAllTaxRatesForCombo() {
    let url = GMN_MENUS_API + 'listtaxratesforcombo';
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteTaxRate(id: string) {
    let url = GMN_MENUS_API + 'deletetaxrate?taxRateId=' + id;
    return this._httpService.httpPost(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  publishTaxRate(model: TaxRateModel) {
    let url = GMN_MENUS_API + 'createtaxrate';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  updateTaxRate(model: TaxRateModel) {
    let url = GMN_MENUS_API + 'updatetaxrate';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  loadTaxRateDetails(id: string) {
    let url = GMN_MENUS_API + 'gettaxratedetails?taxRateId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  loadAllDivisionsForCombo() {
    let url = GMN_MENUS_API + 'listallsubvenuesforcombo';
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
